import { ICONS } from 'components/Icon';
import { useSelector } from 'hooks/useSelector';
import * as React from 'react';
import { selectIsSidebarVisible } from 'store/remote/selectors';
import { IconButton } from 'components/IconButton';
import { useScreenSize } from 'hooks/useScreenSize';
import { ScreenSize } from 'lib/constants';
import { theme } from 'lib/theme';
import { navigationRef } from 'components/Navigation/navigationRef';
import { DrawerActions } from '@react-navigation/native';

export const SidebarShowButton: React.FC<{
  showSmallScreen?: boolean;
  marginRight?: boolean;
}> = ({ showSmallScreen = false, marginRight = true }) => {
  const screenSize = useScreenSize();
  const isSidebarVisible = useSelector(selectIsSidebarVisible);
  if (
    isSidebarVisible ||
    (!showSmallScreen && screenSize === ScreenSize.small)
  ) {
    return false;
  }
  return (
    <IconButton
      icon={ICONS.SidebarLight}
      onPress={() =>
        navigationRef.current?.dispatch(DrawerActions.openDrawer())
      }
      style={marginRight ? { marginRight: theme.paddingHorizontal } : undefined}
    />
  );
};
